export enum Endpoint {
	Autenticate = 'web0053/caricaDatiPublic',
	GetPickupPointData = 'web0053/caricaPickupPointPublic',
	CreateReturn = 'web0053/inserisciAggiornaDatiUtenteResoPublic',
	CheckReturnCode = 'web0053/verificaReturnCodePublic'
}